import list from './list';
import create from './create';
import update from './update';
import show from './show'
import correction from './correction';
import del from './delete';

export default {
  namespaced: true,
  modules: {
    list,
    create,
    update,
    show,
    del,
    correction
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/invoice/index.js